import { BrowserRouter, Route, Routes } from 'react-router-dom'
import React from "react";
import {LoginScreen} from "../screens/LoginScreen";
import {UserScreen} from "../screens/admin/UsersScreen";
import {MainScreen} from "../screens/MainScreen";
import {FilialsScreen} from "../screens/admin/FilialsScreen";
import {ObjectsScreen} from "../screens/admin/ObjectsScreen";
import {EquipmentsScreen} from "../screens/admin/EquipmentsScreen";
import {UserTasksScreen} from "../screens/UserTasksScreen";
import {CreateTaskScreen} from "../screens/CreateTaskScreen";
import {UpdateTaskScreen} from "../screens/UpdateTaskScreen";
import {ViewTaskScreen} from "../screens/ViewTaskScreen";
import {ExecutorScreen} from "../screens/ExecutorScreen";
import {TasksScreen} from "../screens/admin/TasksScreen";
import {WidgetsScreen} from "../screens/admin/WidgetsScreen";
import {Sencha} from "../screens/Sencha";

export const Router: React.FC = () => {
    return (<BrowserRouter>
        <Routes>
            <Route
                path='/'
                element={<MainScreen/>}
            />
            <Route
                path='/my'
                element={<UserTasksScreen/>}
            />
            <Route
                path='/login'
                element={<LoginScreen/>}
            />
            <Route
                path='/users'
                element={<UserScreen/>}
            />
            <Route
                path='/filials'
                element={<FilialsScreen/>}
            />
            <Route
                path='/objects'
                element={<ObjectsScreen/>}
            />
            <Route
                path='/equipments'
                element={<EquipmentsScreen/>}
            />
            <Route
                path='/my/createTask'
                element={<CreateTaskScreen />}
            />
            <Route
                path='/my/updateTask/:id'
                element={<UpdateTaskScreen />}
            />
            <Route
                path='/my/task/:id'
                element={<ViewTaskScreen />}
            />
            <Route
                path='/requests'
                element={<TasksScreen/>}
            />
            <Route
                path='/widgets'
                element={<WidgetsScreen/>}
            />
            <Route
                path='/sencha'
                element={<Sencha/>}
            />
            <Route
                path='*'
                element={<div>четыреста четыре нот фаунд))</div>}
            />
        </Routes>
    </BrowserRouter>)
};